var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useMemo, useState, useCallback } from "react";
import useCommonProps from "../../../hooks/useCommonProps";
import { AuthBlock } from "./components/auth/CommentAuth";
import { CommentEdit } from "./components/edit/CommentEdit";
import { COMMENT_EDIT_MODE, COMMENT_INIT_OFFSET, COMMENT_OFFSET, COMMENTS_ALLOWED_TYPE } from "./const/const";
import { useDispatch, useSelector } from "react-redux";
import { fetchChatData, fetchMoreChatData, onReset, onUpdateChatState, onUpdatePermissions } from "../../../actions/chatActions";
import CommentsList from "./components/list/CommentList";
import { useGetCommentsHandlers } from "./handlers/CommentHandlers";
import { CountTitle, InfoTime } from "./styles";
import { getChat } from "../../../reducers/chatReducer";
import { FlexBox, Skeleton } from "@brg/ui";
import { commentDeckl } from "./components/support/CommentDeckl";
import { Shevron } from "./assets/Shevron";
import useLocalization from "../../../hooks/useLocalization";
import { useAuth, useProfile } from "@brg/auth";
import { useModal } from "../../../core/modules/modal.module";
import { formatDate, formatPostDate } from "./components/support/formatDate";
import { createPortal } from "react-dom";
import { CommentCount } from "./assets/CommentCount";
export var CommentViewController = function (_a) {
    var _b = _a.post, postEntityId = _b.postId, dateCreate = _b.dateCreate, dateLastChange = _b.dateLastChange, created = _a.created, _c = _a.allowedType, allowedType = _c === void 0 ? COMMENTS_ALLOWED_TYPE.post : _c;
    var _d = useCommonProps(), commentsAllowed = _d.commentsAllowed, longreadId = _d.longreadId, isEditable = _d.isEditable;
    var dispatch = useDispatch();
    var profile = useProfile();
    var modal = useModal();
    var auth = useAuth();
    var _e = useLocalization(), t = _e.t, language = _e.language;
    var _f = useState(Date.now()), updateData = _f[0], setUpdateData = _f[1];
    var _g = useState(false), editorVisible = _g[0], toggleEditor = _g[1];
    var _h = useState(false), listVisible = _h[0], toggleList = _h[1];
    var _j = useState(null), morePortal = _j[0], setMorePortal = _j[1];
    var _k = useSelector(function (store) { return getChat(store); }), posts = _k.posts, answerId = _k.answerId, creatingId = _k.creatingId;
    var calcData = useMemo(function () {
        var _a;
        return ((_a = posts === null || posts === void 0 ? void 0 : posts.find(function (post) { return (post === null || post === void 0 ? void 0 : post.entityId) === postEntityId; })) === null || _a === void 0 ? void 0 : _a.pageModel) || undefined;
    }, [posts, postEntityId]);
    var data = useMemo(function () {
        return (calcData === null || calcData === void 0 ? void 0 : calcData.data) || undefined;
    }, [calcData]);
    var paging = useMemo(function () { return ((calcData === null || calcData === void 0 ? void 0 : calcData.paging) || undefined); }, [calcData]);
    var isCommentLoading = useMemo(function () {
        return !!creatingId;
    }, [creatingId]);
    var isPostLoading = useMemo(function () {
        var _a;
        return (_a = ['loading', 'update']) === null || _a === void 0 ? void 0 : _a.includes(postEntityId);
    }, [postEntityId]);
    var onUpdateData = useCallback(function () {
        setUpdateData(Date.now());
        toggleEditor(false);
        toggleList(true);
    }, []);
    var onToggleSwitcherMode = useCallback(function () {
        if (!profile) {
            modal.show('templateModal', {
                mainText: t('chat.auth.title'),
                confirmText: t('chat.auth.button'),
                secondText: t('chat.auth.subtitle'),
                cancelText: t('chat.modal.cancel'),
                onConfirm: function () {
                    auth.login();
                },
                onSecond: function () {
                    modal.hide();
                }
            });
            return;
        }
        toggleEditor(!editorVisible);
    }, [editorVisible, profile]);
    var handlers = useGetCommentsHandlers(onUpdateData);
    var fetchComments = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setTimeout(function () {
                dispatch(fetchChatData({
                    entityId: postEntityId,
                    entityType: allowedType,
                    longreadId: longreadId
                }));
                toggleList(true);
            }, 1000);
            return [2 /*return*/];
        });
    }); };
    var onIconClick = useCallback(function () {
        if (allowedType === COMMENTS_ALLOWED_TYPE.team)
            return;
        if (!listVisible) {
            fetchComments();
            return;
        }
        toggleList(false);
    }, [
        listVisible,
        data,
        postEntityId,
        allowedType,
        toggleList,
        dispatch,
    ]);
    var countData = useMemo(function () {
        if (isNaN(paging === null || paging === void 0 ? void 0 : paging.count))
            return 0;
        return (paging === null || paging === void 0 ? void 0 : paging.count) || 0;
    }, [listVisible, language, paging, data]);
    var countTitle = useMemo(function () {
        if (countData === 0) {
            return null;
        }
        return (React.createElement(FlexBox, { onClick: onIconClick },
            React.createElement(CommentCount, { text: t("chat.".concat(((data === null || data === void 0 ? void 0 : data.length) > 1 && !!listVisible) ? 'hide_comments_list' : 'comment_title')), count: countData, rotate: !listVisible, onClick: onIconClick })));
    }, [
        paging,
        language,
        countData,
        data,
        listVisible,
        allowedType,
        toggleList,
        onIconClick,
        dispatch
    ]);
    var modeSwitcher = useMemo(function () {
        return (React.createElement(CountTitle, { style: { textDecoration: 'underline' }, onClick: onToggleSwitcherMode }, editorVisible ? t('chat.cancel') : t('chat.add')));
    }, [editorVisible, language, listVisible]);
    var postInfo = useMemo(function () {
        if (isPostLoading)
            return null;
        return React.createElement(InfoTime, { largeSize: true },
            formatPostDate(dateCreate, dateLastChange, language),
            "\u00A0");
    }, [language, dateCreate, dateLastChange, isPostLoading]);
    var tabs = useMemo(function () {
        if (isPostLoading || isCommentLoading) {
            return null;
        }
        if (allowedType === COMMENTS_ALLOWED_TYPE.post) {
            if (!!countTitle) {
                return (React.createElement(FlexBox, { offsetTop: 16, width: '100%', justify: "space-between" },
                    React.createElement(FlexBox, { direction: "row", align: "center", gx: 16 },
                        countTitle,
                        modeSwitcher),
                    postInfo));
            }
            return (React.createElement(FlexBox, { offsetTop: 16, width: '100%', justify: "space-between" },
                React.createElement(FlexBox, { direction: "row", align: "center" }, modeSwitcher),
                postInfo));
        }
        return (React.createElement(FlexBox, { width: '100%', justify: "space-between" }, countTitle));
    }, [allowedType, isPostLoading, isCommentLoading, language, listVisible, editorVisible, paging]);
    var editBlock = useMemo(function () {
        if (!editorVisible)
            return null;
        return (React.createElement(CommentEdit, { postEntityId: postEntityId, entityId: postEntityId, mode: COMMENT_EDIT_MODE.add, onUpdate: onUpdateData }));
    }, [editorVisible, onUpdateData, postEntityId]);
    var listBlock = useMemo(function () {
        return (React.createElement(CommentsList, { postEntityId: postEntityId, onUpdate: onUpdateData, time: updateData, handlers: handlers, postHidden: !listVisible, toggleHidden: function () { return toggleList(false); } }));
    }, [listVisible, postEntityId, handlers, updateData, onUpdateData]);
    // const authBlock = useMemo(() => {
    //     return (
    //         <AuthBlock />
    //     )
    // } , [profile])
    if (!commentsAllowed) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        tabs,
        editBlock,
        listBlock));
};
//# sourceMappingURL=CommentViewController.js.mapvar __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useMemo, useState, useCallback } from "react";
import useCommonProps from "../../../hooks/useCommonProps";
import { AuthBlock } from "./components/auth/CommentAuth";
import { CommentEdit } from "./components/edit/CommentEdit";
import { COMMENT_EDIT_MODE, COMMENT_INIT_OFFSET, COMMENT_OFFSET, COMMENTS_ALLOWED_TYPE } from "./const/const";
import { useDispatch, useSelector } from "react-redux";
import { fetchChatData, fetchMoreChatData, onReset, onUpdateChatState, onUpdatePermissions } from "../../../actions/chatActions";
import CommentsList from "./components/list/CommentList";
import { useGetCommentsHandlers } from "./handlers/CommentHandlers";
import { CountTitle, InfoTime } from "./styles";
import { getChat } from "../../../reducers/chatReducer";
import { FlexBox, Skeleton } from "@brg/ui";
import { commentDeckl } from "./components/support/CommentDeckl";
import { Shevron } from "./assets/Shevron";
import useLocalization from "../../../hooks/useLocalization";
import { useAuth, useProfile } from "@brg/auth";
import { useModal } from "../../../core/modules/modal.module";
import { formatDate, formatPostDate } from "./components/support/formatDate";
import { createPortal } from "react-dom";
import { CommentCount } from "./assets/CommentCount";
export var CommentViewController = function (_a) {
    var _b = _a.post, postEntityId = _b.postId, dateCreate = _b.dateCreate, dateLastChange = _b.dateLastChange, created = _a.created, _c = _a.allowedType, allowedType = _c === void 0 ? COMMENTS_ALLOWED_TYPE.post : _c;
    var _d = useCommonProps(), commentsAllowed = _d.commentsAllowed, longreadId = _d.longreadId, isEditable = _d.isEditable;
    var dispatch = useDispatch();
    var profile = useProfile();
    var modal = useModal();
    var auth = useAuth();
    var _e = useLocalization(), t = _e.t, language = _e.language;
    var _f = useState(Date.now()), updateData = _f[0], setUpdateData = _f[1];
    var _g = useState(false), editorVisible = _g[0], toggleEditor = _g[1];
    var _h = useState(false), listVisible = _h[0], toggleList = _h[1];
    var _j = useState(null), morePortal = _j[0], setMorePortal = _j[1];
    var _k = useSelector(function (store) { return getChat(store); }), posts = _k.posts, answerId = _k.answerId, creatingId = _k.creatingId;
    var calcData = useMemo(function () {
        var _a;
        return ((_a = posts === null || posts === void 0 ? void 0 : posts.find(function (post) { return (post === null || post === void 0 ? void 0 : post.entityId) === postEntityId; })) === null || _a === void 0 ? void 0 : _a.pageModel) || undefined;
    }, [posts, postEntityId]);
    var data = useMemo(function () {
        return (calcData === null || calcData === void 0 ? void 0 : calcData.data) || undefined;
    }, [calcData]);
    var paging = useMemo(function () { return ((calcData === null || calcData === void 0 ? void 0 : calcData.paging) || undefined); }, [calcData]);
    var isCommentLoading = useMemo(function () {
        return !!creatingId;
    }, [creatingId]);
    var isPostLoading = useMemo(function () {
        var _a;
        return (_a = ['loading', 'update']) === null || _a === void 0 ? void 0 : _a.includes(postEntityId);
    }, [postEntityId]);
    var onUpdateData = useCallback(function () {
        setUpdateData(Date.now());
        toggleEditor(false);
        toggleList(true);
    }, []);
    var onToggleSwitcherMode = useCallback(function () {
        if (!profile) {
            modal.show('templateModal', {
                mainText: t('chat.auth.title'),
                confirmText: t('chat.auth.button'),
                secondText: t('chat.auth.subtitle'),
                cancelText: t('chat.modal.cancel'),
                onConfirm: function () {
                    auth.login();
                },
                onSecond: function () {
                    modal.hide();
                }
            });
            return;
        }
        toggleEditor(!editorVisible);
    }, [editorVisible, profile]);
    var handlers = useGetCommentsHandlers(onUpdateData);
    var fetchComments = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setTimeout(function () {
                dispatch(fetchChatData({
                    entityId: postEntityId,
                    entityType: allowedType,
                    longreadId: longreadId
                }));
                toggleList(true);
            }, 1000);
            return [2 /*return*/];
        });
    }); };
    var onIconClick = useCallback(function () {
        if (allowedType === COMMENTS_ALLOWED_TYPE.team)
            return;
        if (!listVisible) {
            fetchComments();
            return;
        }
        toggleList(false);
    }, [
        listVisible,
        data,
        postEntityId,
        allowedType,
        toggleList,
        dispatch,
    ]);
    var countData = useMemo(function () {
        if (isNaN(paging === null || paging === void 0 ? void 0 : paging.count))
            return 0;
        return (paging === null || paging === void 0 ? void 0 : paging.count) || 0;
    }, [listVisible, language, paging, data]);
    var countTitle = useMemo(function () {
        if (countData === 0) {
            return null;
        }
        return (React.createElement(FlexBox, { onClick: onIconClick },
            React.createElement(CommentCount, { text: t("chat.".concat(((data === null || data === void 0 ? void 0 : data.length) > 1 && !!listVisible) ? 'hide_comments_list' : 'comment_title')), count: countData, rotate: !listVisible, onClick: onIconClick })));
    }, [
        paging,
        language,
        countData,
        data,
        listVisible,
        allowedType,
        toggleList,
        onIconClick,
        dispatch
    ]);
    var modeSwitcher = useMemo(function () {
        return (React.createElement(CountTitle, { style: { textDecoration: 'underline' }, onClick: onToggleSwitcherMode }, editorVisible ? t('chat.cancel') : t('chat.add')));
    }, [editorVisible, language, listVisible]);
    var postInfo = useMemo(function () {
        if (isPostLoading)
            return null;
        return React.createElement(InfoTime, { largeSize: true },
            formatPostDate(dateCreate, dateLastChange, language),
            "\u00A0");
    }, [language, dateCreate, dateLastChange, isPostLoading]);
    var tabs = useMemo(function () {
        if (isPostLoading || isCommentLoading) {
            return null;
        }
        if (allowedType === COMMENTS_ALLOWED_TYPE.post) {
            if (!!countTitle) {
                return (React.createElement(FlexBox, { offsetTop: 16, width: '100%', justify: "space-between" },
                    React.createElement(FlexBox, { direction: "row", align: "center", gx: 16 },
                        countTitle,
                        modeSwitcher),
                    postInfo));
            }
            return (React.createElement(FlexBox, { offsetTop: 16, width: '100%', justify: "space-between" },
                React.createElement(FlexBox, { direction: "row", align: "center" }, modeSwitcher),
                postInfo));
        }
        return (React.createElement(FlexBox, { width: '100%', justify: "space-between" }, countTitle));
    }, [allowedType, isPostLoading, isCommentLoading, language, listVisible, editorVisible, paging]);
    var editBlock = useMemo(function () {
        if (!editorVisible)
            return null;
        return (React.createElement(CommentEdit, { postEntityId: postEntityId, entityId: postEntityId, mode: COMMENT_EDIT_MODE.add, onUpdate: onUpdateData }));
    }, [editorVisible, onUpdateData, postEntityId]);
    var listBlock = useMemo(function () {
        return (React.createElement(CommentsList, { postEntityId: postEntityId, onUpdate: onUpdateData, time: updateData, handlers: handlers, postHidden: !listVisible, toggleHidden: function () { return toggleList(false); } }));
    }, [listVisible, postEntityId, handlers, updateData, onUpdateData]);
    // const authBlock = useMemo(() => {
    //     return (
    //         <AuthBlock />
    //     )
    // } , [profile])
    if (!commentsAllowed) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        tabs,
        editBlock,
        listBlock));
};
//# sourceMappingURL=CommentViewController.js.map